import FontBody2 from '../../../../../../../components/fonts/font-body2/font-body2';
import { FONT_COLOR } from '../../../../../../../components/fonts/font-props';

import { ItemEligibilityDto, PolicyResult } from '../../order-eligibility-display.service';

import EligiblePoliciesSection from './eligible-policies-section';
import FailedChecksSection from './failed-checks-section';
import PolicyResultsSection from './policy-results-section';

interface ItemCardContentProps {
    item: ItemEligibilityDto;
    isEligible: boolean;
    eligiblePolicyEvaluations: any[];
    failedChecks: Array<{
        policyName: string;
        level: string;
        reason: string;
    }>;
    policyResults: PolicyResult[];
}

const ItemCardContent: React.FC<ItemCardContentProps> = ({ 
    item, 
    isEligible, 
    eligiblePolicyEvaluations, 
    failedChecks, 
    policyResults 
}) => {
    return (
        <div className="item-card-content">
            {/* Show eligible policies and their resolutions */}
            {isEligible && (
                <EligiblePoliciesSection eligiblePolicyEvaluations={eligiblePolicyEvaluations} />
            )}
            
            {/* Show failed eligibility checks - collapsed by default for eligible items */}
            <FailedChecksSection failedChecks={failedChecks} isEligible={isEligible} />
            
            {/* Show all policy results in a collapsible section */}
            <PolicyResultsSection policyResults={policyResults} />
            
            {/* Show no_policies_reason if item is ineligible */}
            {!isEligible && item.no_policies_reason && (
                <FontBody2 color={FONT_COLOR.SEMANTIC_DANGER}>
                    Reason: {item.no_policies_reason}
                </FontBody2>
            )}
            
            {/* Fallback message if no policy results found */}
            {policyResults.length === 0 && !item.no_policies_reason && (
                <FontBody2 color={FONT_COLOR.SEMANTIC_DANGER}>
                    No policy rules found for this item
                </FontBody2>
            )}
        </div>
    );
};

export default ItemCardContent;
